import React, { useEffect, useState } from 'react'
import './HorizontalContinueWatchingCard.scss'
import classNames from 'classnames'
import { CardProps, RailDetailsItem, ResumeWatchingItem } from '@interfaces/index'
import { ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import { DocumentData } from 'firebase/firestore'
import Image from '@components/Image/Image'
import Text from '@components/Text/Text'
import { categoryType } from '@constants/category.const'
import { TextTag } from '@enums/textTag'
import FallbackImage from '@components/FallbackImage/FallbackImage'
import { VelvetSDK } from 'sdk'
import { PageData } from 'sdk/services/cms/types/cmsService'
import { useUserCountry } from 'contexts/userCoutryContext'
import { getActiveProfile } from '@utils/helpers'

interface HorizontalContinueWatchingCardProps {
  item: ResumeWatchingItem | CardProps | RailDetailsItem | DocumentData
  isActive?: boolean
}

const HorizontalContinueWatchingCard = ({ item, isActive }: HorizontalContinueWatchingCardProps) => {
  const { title, contextData, slug, parentImage } = item
  const backgroundImage = contextData?.imageCard ?? parentImage ?? ''
  const transformedImage = useImgUrlTransform(backgroundImage, ImageSize.HORIZONTAL_CARD)
  const [serie, setSerie] = useState<PageData>()
  const [seasonInfo, setSeasonInfo] = useState<number>()
  const [episodeInfo, setEpisodeInfo] = useState<number>()
  const showAdditionalInfo = item.parentType === categoryType.SERIE && seasonInfo && episodeInfo
  const userCountry = useUserCountry()
  const activeProfile = getActiveProfile()
  const renderProgress = (resourceDuration: number, watchedDuration: number, isActive?: boolean) => {
    const width = resourceDuration > 0 ? (watchedDuration / resourceDuration) * 100 : 0
    return (
      <div className={classNames('hcw-type__progress', { 'hcw-type__progress--focus': isActive })}>
        <div className="hcw-type__progress--active" style={{ width: `${width}%` }}></div>
      </div>
    )
  }

  useEffect(() => {
    if (item.parentType === categoryType.SERIE) {
      VelvetSDK.CMS.service()
        .fetchDetails(item.parentType, item.parentSlug, false, activeProfile?.preferredLanguage, userCountry)
        .then((serie) => setSerie(serie))
    }
  }, [activeProfile?.preferredLanguage, item.parentSlug, item.parentType, userCountry])

  useEffect(() => {
    if (serie) {
      const seasonIndex = serie?.seasons?.findIndex((season) => season.episodes?.some((episode) => episode.id === slug))

      if (seasonIndex !== undefined && seasonIndex !== -1) {
        setSeasonInfo(seasonIndex + 1)
        const episodeIndex =
          serie.seasons && serie.seasons[seasonIndex]?.episodes?.findIndex((episode) => episode.id === slug)

        if (episodeIndex !== undefined && episodeIndex !== -1) {
          setEpisodeInfo(episodeIndex + 1)
        }
      }
    }
  }, [serie, slug])

  return (
    <div className="hcw-type">
      <div
        className={classNames('hcw-type__focus', {
          'hcw-type__focused': isActive,
        })}
      >
        <div className="hcw-type__focus--wrapper">
          <Text tag={TextTag.P} className="hcw-type__focus--wrapper--title">
            {item.parentTitle}
          </Text>
          <Text tag={TextTag.P} className="hcw-type__focus--wrapper--subtitle">
            {showAdditionalInfo && `S${seasonInfo}:E${episodeInfo}  ${item.title}`}
          </Text>
        </div>
        {renderProgress(item.resourceDuration, item.watchedDuration, isActive)}
      </div>
      <div
        className={classNames('hcw-type__container', {
          'hcw-type__focused': isActive,
        })}
      >
        <div className={classNames('card-image-wrapper', { 'row-card-image-focused': isActive })}>
          {backgroundImage ? <Image image={transformedImage} alt={title} fallbackOnLoad /> : <FallbackImage />}
        </div>
        {!isActive && renderProgress(item.resourceDuration, item.watchedDuration, isActive)}
      </div>
    </div>
  )
}
export default HorizontalContinueWatchingCard
